import { Email, from } from '@phi/newtype';
import { DataLayer } from '../datalayer';

export const log_user_registration = (datalayer: DataLayer | Error) => (email: Email, source: 'phi' | 'onshape') => {
    if (datalayer instanceof Error)
        return;
    else {
        datalayer.push({
            'event': 'OnRegistration',
            'sourcePlatform': source,
            'email': from(email),
        });
        const str = `OnRegistration ${source} ${from(email)}`;
        console.log(str);
    }
};
